import { DropTarget } from 'react-dnd-compat';
import { jsx as _jsx } from "react/jsx-runtime";
const dropTypes = [];
const dropSpec = {
  drop() {
    return null;
  }
};
const dropCollect = monitor => ({
  isOver: monitor.isOver()
});
function FakeDropTarget({
  connectDropTarget
}) {
  return connectDropTarget( /*#__PURE__*/_jsx("div", {
    style: {
      position: 'absolute',
      top: -1000,
      left: -1000,
      width: 0,
      height: 0
    }
  }));
}
export default DropTarget(dropTypes, dropSpec, dropCollect)(FakeDropTarget);